import React from 'react'
import { useTranslation } from 'next-i18next'
import { Head, PaymentTypes } from '../../../src/component'
import { TrackOnMount } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { TrackingEvent } from '../../../src/model/monitoring'
import { useOfferDetailPCL, useOpenExistingFacility, usePBIRejected, usePreselectedPaymentType } from '../../../src/state'

export const PaymentTypesPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const pageTitle = `${t('consumerLending:paymentOptions:title')} | ${t('common:brandName')}`

  const openExistingFacility = useOpenExistingFacility()
  const offerDetailPCL = useOfferDetailPCL()
  const isPbiRejected = usePBIRejected()
  const preselectedPaymentType = usePreselectedPaymentType()

  return (
    <>
      <Head title={pageTitle} />
      <PaymentTypes />
      <TrackOnMount
        eventName={TrackingEvent.VIEWED_CL_ENTRY_PAGE}
        eventProperties={{
          hasExistingFacility: openExistingFacility,
          hasPCLEnabled: Boolean(offerDetailPCL),
          hasPBIEnabled: !isPbiRejected,
          preSelected: preselectedPaymentType ?? 'None',
        }}
      />
    </>
  )
}
